import {Component, Input, OnInit, EventEmitter, Output, ViewChild, ElementRef, ChangeDetectorRef, output, input, effect, ViewEncapsulation, Renderer2} from '@angular/core';
import {FormsService} from '../forms.service';
import {ISqlJob} from '../../jobs/sql-job.interface';
import {JobsService} from '../../jobs/jobs.service';
import {Job} from '../../jobs/job';
import {MessageService} from 'primeng/api';
import {ConfirmationService} from 'primeng/api';
import { Loading } from 'notiflix';
import { NotesService } from '../../notes/notes.service';
import { removeObject, changeProps } from 'find-and';
import { FormioComponent } from '@formio/angular';
import { Form } from '../form.interface';
import { InspectionFormService } from './inspection-form.service';

export interface IFormState {
  data: any;
  isValid: boolean;
  isModified: boolean;
  job?: Job;
}

@Component({
  selector: 'app-inspection-form',
  queries: {
    formViewContent: new ViewChild( `formViewContent`)
  },
  templateUrl: './inspection-form.component.html',
  styleUrls: ['./inspection-form.component.scss'],
})
export class InspectionFormComponent implements OnInit {
  form: Form = {} as Form;
  formDef: any;
  formData: any = {};
  isSaveFinal = false;
  isFormClosed = false;
  isFormValid = true;

  formioOptions = {
    highlightErrors: true,
    hooks: {
      beforeSubmit: (submission: any, next: any) => {
        if (this.isFormValid) {
          next(null, submission);
        } else {
          this.formViewContentRef.nativeElement.scrollTo(0, 0);
        }
      }
    },
  };

  @Input()
  scJob: ISqlJob = {} as ISqlJob;

  @Input()
  showButtons: boolean = false;

  @Input()
  showFormioButtons: boolean = true;

  dataEditTimestamp: Date|null = null;
  @Output()
  editTimestampChange: EventEmitter<Date> = new EventEmitter<Date>();

  job: Job = {} as Job;

  @Output()
  closeEvent: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  hasUnsavedFormChanges: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  onFormStateChange: EventEmitter<any> = new EventEmitter<any>();

  public formViewContentRef!: ElementRef;

  formClosed = input<boolean>(false, {alias: 'isFormClosed'});
  saveFinals = input<boolean>(false, {alias: 'isSaveFinal'});

  formioComponent!: FormioComponent;

  viewOnly = false;

  constructor(
    private formsService: FormsService,
    private jobsService: JobsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private notesService: NotesService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private inspectionFormService: InspectionFormService
  ) {
    effect(() => {
      this.isFormClosed = this.formClosed();
    });
    effect(() => {
      this.isSaveFinal = this.saveFinals();
    });
  }

  async ngOnInit(): Promise<void> {
    if (!this.scJob) {
      return;
    }

    try {
      const { form, formData, job, viewOnly } = await this.inspectionFormService.initializeFormData(this.scJob);
      this.formDef = form;
      this.formData = formData;
      this.job = job;
      this.viewOnly = viewOnly;
      this.dataEditTimestamp = new Date();
      this.editTimestampChange.emit(this.dataEditTimestamp);
      this.removeFormioButtons(this.formDef);
    } catch (error) {
      console.error('Error initializing inspection form:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error Loading Form',
        detail: 'There was an error loading the inspection form. Please try again or contact support.'
      });
    } finally {
      this.cdr.markForCheck();
    }
  }

  // async submitQcReview(formio: any, formData: any): Promise<void> {
  //   const confirmed = await this.inspectionFormService.confirmAction(
  //     'Are you sure you want to submit this form for QC review?'
  //   );

  //   if (!confirmed) {
  //     formio.formio.emit('submitError', 'Form submission was canceled.');
  //     return;
  //   }

  //   try {
  //     await this.inspectionFormService.submitToQc(this.job.id, this.getFormioInstance());
  //     this.isSaveFinal = true;
  //     formio.formio.emit('submitDone', 'Form successfully submitted for QC review. You can now close the form.');
  //     this.hasUnsavedFormChanges.emit(false);
  //     this.closeEvent.emit('onClose');
  //   } catch (error) {
  //     formio.formio.emit('submitError', `Unable to submit form: ${error}`);
  //   }
  // }

  onFormChange(e: any): void {
    if (e.isModified) {
      this.hasUnsavedFormChanges.emit(true);
      this.onFormStateChange.emit(e);
    }
  }

  // onSubmit(formio: any, submission: any): void {
  //   // this.submitQcReview(formio, submission.data);
  // }

  async onCustomEvent(formio: any, event: any): Promise<boolean> {
    switch (event.type) {
      case 'save':
        try {
          // await this.inspectionFormService.saveFormProgress(this.job.id, event.data);
          this.hasUnsavedFormChanges.emit(false);
        } catch (error) {
          // Error handling is done in the service
        }
        break;

      case 'saveFinal':
        // await this.submitQcReview(formio, event.data);
        break;

      case 'close':
        const confirmed = await this.inspectionFormService.confirmAction('Are you sure you want to close the form?');
        if (confirmed) {
          this.isFormClosed = true;
          this.closeEvent.emit('onClose');
        }
        break;
    }
    return true;
  }

  reopenForm(): void {
    this.isFormClosed = false;
  }

  onFormInvalid(e: any): void {
    this.isFormValid = false;
    this.formViewContentRef.nativeElement.scrollTo(0, 0);
  }

  removeFormioButtons(formDef: any): void {
    this.formDef = removeObject(formDef, { type: 'button' });
  }

  formReady(formComponent: FormioComponent): void {
    this.formioComponent = formComponent;
  }

  getFormioInstance(): FormioComponent {
    return this.formioComponent;
  }
}
